export default __webpack_public_path__ + "static/media/lawyer.9e5bcbdb.svg";